module.exports = __webpack_public_path__ + "img/ug413.f213898a.png";